import React, {useContext, useState} from "react";
import { Box, TextField, Button } from '@mui/material';
import MainLayout from "../../components/MainLayout";

/**
 * @author Sarthak Sharma.
 * @since 27-12-2023.
 * @description Actor management page.
 */

const InfluencerManagement = (): React.ReactElement => {

    return (
        <MainLayout>
            <Box className="relative w-full flex flex-col gap-8 items-center p-4 py-12">
                <Box className="w-full max-w-[800px] flex flex-wrap bg-white rounded-[12px] border-[2px] border-[#E8E8E9] px-3 py-7">
                    <h2 className="w-full text-center font-['Poppins-Semibold'] text-5xl text-zinc-500">Coming Soon</h2>
                </Box>
            </Box>
        </MainLayout>
    );
}

export default React.memo(InfluencerManagement, () => true);